import api from '../api';
import store from '../../store';
import { ILoginParams } from './types';
import { getUCUrl } from '../https';

export const logout = () => {
  api.post(getUCUrl('/quitLogin'));
  store.dispatch('user/userAction', null);
};

export const login = (params: ILoginParams) => api.post(getUCUrl('/login'), {
  ...params,
  'appkey': process.env.VUE_APP_THEMIS_APP_KEY,
  'appSecret': process.env.VUE_APP_THEMIS_APP_SECRET,
});

export const own = async () => {
  const data = await api.get(getUCUrl('/getOwn'), { params: { timestamp: new Date().getTime() } });
  return data;
};

export const register = (params: any) => api.post(getUCUrl('/createBusinessUser'), {
  ...params,
  'appkey': process.env.VUE_APP_THEMIS_APP_KEY,
  'appSecret': process.env.VUE_APP_THEMIS_APP_SECRET,
});

export const ipCreate = (params: any) => api.post(getUCUrl('/ip/create'), {
  ...params,
});

/**
 * 获取企业列表
 * @returns
 */
export const getCustomers = () => {
  return api.get(getUCUrl('/businessOrg/getUserAndOrgList'));
};

/**
 * 通过企业ID获取企业应用
 * @param data
 * @returns
 */
export const getAppKeysByOId = (data: { orgIds: number[] }) => {
  return api.post(getUCUrl('/orgAppl/getAllByOrg'), data);
};

/**
 * 更新当前用户密码
 * @param data
 * @returns
 */
export const updatePassword = (data: { newPassword: string; oldPassword: string }) => {
  return api.post(getUCUrl('/updatePassword'), data);
};

/**
 * 通过企业ID获取企业信息
 * @param data
 * @returns
 */
export const getOrgInfoByOId = (params: { orgId: number }) => {
  return api.get(getUCUrl('/businessOrg/getOne'), params);
};

export const getOrgList = () => {
  return api.get(getUCUrl('/businessOrg/getAll'));
};
